export default path => '/tires/winter-snow'.includes(path)
